module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/congratulations/2002_congratulations-d471fec063ebcb254cec3cefdbb8d44e.jpg";